import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";

interface QuestionnaireLoaderProps {
  reason: string;
}

export const QuestionnaireLoader = ({ reason }: QuestionnaireLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center h-64 space-y-4">
      <Spinner />
      <p className="text-sm text-muted-foreground">
        {t("questionnaires.loadingStates." + reason)}
      </p>
    </div>
  );
};
